import {OtsUIState} from "../../ots-ui-store";

export const selectUIProductionVolumeSearchFilter = (state: OtsUIState) => state.uiProductionVolume.searchFilter
